module.exports = __webpack_public_path__ + "static/img/100x100_ICONS_2.952f507.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/100x100_ICONS_2.png
// module id = SwfB
// module chunks = 0